import React, { useEffect, useRef, useState } from 'react';

/**
 * CoffrasPrototip: Coffras web sitesinin tıklanabilir prototipi.
 * Route: /r/coffras-web/prototip (sidebar YOK, tam ekran).
 * Üstte araç çubuğu: sayfa seçici + masaüstü/mobil görünüm.
 * Kaynak src/pages/coffras-web/prototip.html, yeniden: node src/pages/coffras-web/build-prototip.js
 */
const SAYFALAR = [
  ['ana', 'Ana sayfa'],
  ['finansal-danismanlik', 'Finansal Danışmanlık'],
  ['kurumsal-finansman', 'Kurumsal Finansman'],
  ['sirket-degerleme', 'Şirket Değerleme'],
  ['akl', 'AKL Sigorta'],
  ['iletisim', 'İletişim'],
];

export default function CoffrasPrototip() {
  const [html, setHtml] = useState(null);
  const [mobil, setMobil] = useState(false);
  const [sayfa, setSayfa] = useState('ana');
  const frame = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./coffrasPrototipHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Prototip yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // Prototip içinde gezinince seçici de güncellensin.
  useEffect(() => {
    const dinle = (ev) => {
      if (ev.source === frame.current?.contentWindow && ev.data?.coffrasSayfa) setSayfa(ev.data.coffrasSayfa);
    };
    window.addEventListener('message', dinle);
    return () => window.removeEventListener('message', dinle);
  }, []);

  const git = (ad) => {
    setSayfa(ad);
    frame.current?.contentWindow?.postMessage({ coffrasGit: ad }, '*');
  };

  const dugme = (aktif) => ({
    border: 0, borderRadius: 6, padding: '6px 12px', font: '500 13px system-ui, sans-serif', cursor: 'pointer',
    background: aktif ? '#fff' : 'transparent', color: aktif ? '#14213d' : '#c9cfdb',
  });

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column', background: '#2a2f3a' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', background: '#14161c', flexWrap: 'wrap' }}>
        <b style={{ color: '#fff', font: '600 14px system-ui, sans-serif', marginRight: 6 }}>Coffras · Site prototipi</b>
        <select
          value={sayfa}
          onChange={(e) => git(e.target.value)}
          style={{ background: '#2a2f3a', color: '#fff', border: '1px solid #3a404d', borderRadius: 6, padding: '6px 10px', font: '13px system-ui, sans-serif' }}
        >
          {SAYFALAR.map(([k, ad]) => <option key={k} value={k}>{ad}</option>)}
        </select>
        <div style={{ display: 'flex', gap: 2, background: '#2a2f3a', borderRadius: 8, padding: 3 }}>
          <button type="button" style={dugme(!mobil)} onClick={() => setMobil(false)}>Masaüstü</button>
          <button type="button" style={dugme(mobil)} onClick={() => setMobil(true)}>Mobil</button>
        </div>
        <a href="/r/coffras-web" style={{ marginLeft: 'auto', color: '#c9cfdb', font: '13px system-ui, sans-serif', textDecoration: 'none' }}>← Sunuma dön</a>
      </div>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', overflow: 'hidden', padding: mobil ? '20px 0' : 0 }}>
        {html && (
          <iframe
            ref={frame}
            title="Coffras · Site prototipi"
            srcDoc={html}
            style={{
              border: 0, background: '#fff', height: '100%',
              width: mobil ? 390 : '100%',
              borderRadius: mobil ? 28 : 0,
              boxShadow: mobil ? '0 0 0 10px #0d0f14, 0 30px 60px rgba(0,0,0,.4)' : 'none',
            }}
          />
        )}
      </div>
    </div>
  );
}
